import {DateRange, ShiftQuickSelectSlots} from '@hconnect/common/types'
import {
  generateTimeRangeFromUrlParam,
  getTimeRangeOrQuickSelectSlotsString,
  getUrlParam,
  setOrDeleteStringParam
} from '@hconnect/common/utils'
import {useSearchParams} from 'react-router'

type Props = {
  key: string
  timezone: string
  defaultTimeRange: string
}

export const useTimeRangeParam = ({defaultTimeRange, key, timezone}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const timeRangeParam = getUrlParam(searchParams, key)

  const setTimeRangeParam = (value: ShiftQuickSelectSlots | DateRange) => {
    const timeRangeString = getTimeRangeOrQuickSelectSlotsString(value)
    const newParams = new URLSearchParams(searchParams)

    setOrDeleteStringParam(newParams, key, timeRangeString)
    setSearchParams(newParams)
  }
  return {
    timeRange: generateTimeRangeFromUrlParam(timeRangeParam ?? defaultTimeRange, timezone),
    setTimeRange: setTimeRangeParam
  }
}
